export default "__VITE_ASSET__DH2uAeIr__"